export type HTTPUploadProps = {
  url: string
  body: File
  contentType: string
  onProgress: (percentage: number) => void
}

export const httpUpload = ({
  url,
  body,
  contentType,
  onProgress
}: HTTPUploadProps) =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('PUT', url)
    xhr.setRequestHeader('Content-Type', contentType)
    xhr.upload.onprogress = (event) => {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100)
        onProgress(percentComplete)
      }
    }

    xhr.onload = () => {
      if (xhr.status < 400) {
        resolve(true)
      } else {
        reject(new Error(`Upload failed with status: ${xhr.status}`))
      }
    }

    xhr.onerror = () => {
      reject(new Error('Network error'))
    }

    xhr.send(body)
  })
